// Every report settings schema, by slug. Pages that list reports (the Reports
// index) read titles, descriptions and icons from here, so they always match
// each report's own page.
import alarmConfiguration from "./alarm-configuration"
import alarmResolution from "./alarm-resolution"
import calibration from "./calibration"
import detailedAlarm from "./detailed-alarm"
import excursion from "./excursion"
import mkt from "./mkt"
import occupancy from "./occupancy"
import roomCondition from "./room-condition"
import systemHealth from "./system-health"
import thresholdAchievement from "./threshold-achievement"
import weeklyDeviceSummary from "./weekly-device-summary"

export const REPORT_SCHEMAS = Object.fromEntries([
    alarmConfiguration,
    alarmResolution,
    calibration,
    detailedAlarm,
    excursion,
    mkt,
    occupancy,
    roomCondition,
    systemHealth,
    thresholdAchievement,
    weeklyDeviceSummary,
].map((schema) => [schema.slug, schema]))
